var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-layout form px-0" },
    [
      _c("filter-budget-advanced", {
        attrs: {
          "hide-supplier-section": "",
          "show-type-selector": false,
          "label-expense-details": _vm.FormMSG(148, "Salary details"),
          "hide-expense-details-type": "",
          "hide-co-two-detail": "",
          "use-department-for-salary": "",
          "hide-process-filter": false,
          "filter-type": _vm.FILTER_TYPE.BUDGET_SALARIES,
        },
        on: {
          "filter-budget-advanced:click-selection":
            _vm.handleFilterBudgetAdvancedClickSelection,
        },
      }),
      _c(
        "div",
        { staticClass: "d-flex row align-items-center mt-3 hide-on-tablet" },
        [
          _c(
            "b-col",
            { attrs: { md: "5" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0" },
                [
                  _vm.$screen.width >= 992
                    ? _c(
                        "b-input-group",
                        [
                          _c("filterInputSearch", {
                            attrs: {
                              id: "salaire-id",
                              "init-value": _vm.initValueFilter,
                            },
                            on: {
                              "filtered-users": _vm.activeFilter,
                              "handle-init-filter": _vm.onHandleInitFilter,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "7" } },
            [
              !_vm.haveActiveFilter
                ? _c("custom-pagination", {
                    attrs: {
                      "total-records": _vm.totalRecords,
                      "initial-offset": _vm.offset,
                      "initial-limit": _vm.limit,
                      "filter-type": _vm.FILTER_TYPE.BUDGET_SALARIES,
                    },
                    on: {
                      "custom-pagination:previous": _vm.handleClickLoadMore,
                      "custom-pagination:forward": _vm.handleClickLoadMore,
                      "custom-pagination:change-per-page":
                        _vm.handleClickLoadMore,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row mt-3 px-3" },
        [
          !_vm.$screen.md
            ? _c("CardListBuilder", {
                staticStyle: { width: "100%" },
                attrs: {
                  "custom-class": "hide-on-desktop",
                  items: _vm.salaries,
                  filter: _vm.filter,
                  fields: _vm.bgFieldsMobile,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "actions",
                      fn: function (data) {
                        return [
                          _c(
                            "div",
                            {
                              attrs: { role: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.goToDetail(data.item)
                                },
                              },
                            },
                            [
                              _c("eye", { attrs: { size: 16 } }),
                              _vm._v(
                                " " + _vm._s(_vm.FormMSG(1001, "See details"))
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  785615338
                ),
              })
            : _c("b-table", {
                staticStyle: { width: "100%", "font-weight": "500" },
                attrs: {
                  responsive: "sm",
                  filter: _vm.filter,
                  items: _vm.salaries,
                  fields: _vm.bgFields,
                  "sticky-header": "700px",
                  "head-variant": _vm.hv,
                  hover: true,
                  bordered: "",
                  small: "",
                  "show-empty": "",
                  selectable: "",
                  selectedVariant: _vm.selectedColor,
                  "select-mode": _vm.selectMode,
                  "empty-text": _vm.FormMSG(285, "No budget salaries found"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(processed)",
                    fn: function ({ item, index }) {
                      return [
                        _c(
                          "div",
                          [
                            _c("b-form-checkbox", {
                              attrs: {
                                disabled: !_vm.canMarkEntryAsProcessed,
                                size: "lg",
                                value: true,
                                "unchecked-value": false,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleChangeProcess(
                                    $event,
                                    item,
                                    index
                                  )
                                },
                              },
                              model: {
                                value: item.timesheet.processed,
                                callback: function ($$v) {
                                  _vm.$set(item.timesheet, "processed", $$v)
                                },
                                expression: "item.timesheet.processed",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(categorySelect)",
                    fn: function ({}) {
                      return [
                        _c(
                          "div",
                          [
                            _c("treeselect", {
                              attrs: {
                                options: _vm.allCategories,
                                multiple: false,
                                clearable: false,
                                "disable-branch-nodes": "",
                                "default-expand-level": 1,
                              },
                              on: { input: _vm.handleInputCategorySelect },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "option-label",
                                    fn: function ({ node }) {
                                      return _c("div", {}, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "treeselect-label",
                                            attrs: { title: node.label },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(node.label) +
                                                "\n\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        ),
                                      ])
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(validatedStatus)",
                    fn: function (data) {
                      return [
                        _c("div", { staticClass: "wrap-status" }, [
                          _c(
                            "div",
                            {
                              class: `status ${data.item.statusClass}`,
                              staticStyle: { "font-size": "0.7rem" },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(data.item.validatedStatus) +
                                  "\n\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(detail)",
                    fn: function (data) {
                      return [
                        _c(
                          "div",
                          {
                            attrs: { role: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.goToDetail(data.item)
                              },
                            },
                          },
                          [_c("eye", { attrs: { size: 16 } })],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(salary)",
                    fn: function (data) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-row align-items-center justify-content-end w-100",
                          },
                          [
                            _c("salary-log", {
                              attrs: { item: data.item.timesheet },
                            }),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "2px" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.rendCurrency(data.item.salary))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
        ],
        1
      ),
      _c("script-export-modal", {
        attrs: {
          items: _vm.scripts,
          custom: _vm.customReport,
          "export-type": "ts",
        },
        on: {
          "script-export-modal:loading": _vm.handleTimesheetLoading,
          "script-export-modal:closed": _vm.timeSheetRerpotOnClosed,
        },
        model: {
          value: _vm.isScriptTimeSheetReportOpen,
          callback: function ($$v) {
            _vm.isScriptTimeSheetReportOpen = $$v
          },
          expression: "isScriptTimeSheetReportOpen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }